import { Col, Card, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DETAIL_ROUTE } from "../utils/consts";
import '../css/cards.css'
const DetailItem = ({detail}) => {
    const navigate = useNavigate();
    const placeholder = 'static/placeholder.png'
    return(
        <div className="detail-item">
            <Col md={3} className="m-3">
                <Card 
                    onClick={() => navigate(DETAIL_ROUTE + '/' + detail.id)}
                    style={{
                        width: 250,
                        height: 350,
                        cursor: 'pointer',
                        border: 'none',
                        borderRadius: '15px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        backgroundColor: '#f8f9fa'
                    }}
                    className="hover-card"
                >
                    <div style={{
                        padding: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '15px'
                        }}>
                            <Image 
                                width={180} 
                                height={180} 
                                src={
                                        detail.img && detail.img !== 'default-image.jpg'
                                        ? process.env.REACT_APP_API_URL + 'static/' + detail.img
                                        : process.env.REACT_APP_API_URL + placeholder
                                    }
                                style={{
                                    borderRadius: '10px'
                                }}
                            />
                        </div>
                        <div style={{flex: 1}}>
                            <div style={{
                                fontSize: '14px',
                                color: '#666',
                                marginBottom: '5px'
                            }}>
                                {detail.subType?.name || detail.type.name} • {detail.brand.name}
                            </div>
                            <h5 style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                marginBottom: '10px',
                                color: '#333'
                            }}>
                                {detail.name}
                            </h5>
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            textAlign: 'right',
                            marginTop: 'auto'
                        }}>
                            {detail.price} ₽
                        </div>
                    </div>
                </Card>
            </Col>
        </div>
    );
};

export default DetailItem;